module.exports = __webpack_public_path__ + "img/MapPicsNewInland.b0b8312b.webp";